import { SET_UPDATEFAVOURITE } from '../actions';

const updatefavourite = (state = [], action) => {
  switch (action.type) {
	case SET_UPDATEFAVOURITE:
      return [...action.value];  
    default: return state;
  }
}

export default updatefavourite;
